import { createFileRoute } from '@tanstack/react-router';

// relative imports
import SourcesPage from '../../../../../../components/source-management/sources-page/SourcesPage';
import LoadingPage from '../../../../../../components/shared/page-components/LoadingPage';

export const Route = createFileRoute(
  '/_authenticated/client/$accountId/_clientWrapper/(sources)/sources/',
)({
  pendingComponent: () => <LoadingPage loadingPage />,
  component: SourcesPage,
  staticData: {
    configPageId: 'crypto-sources',
    isClientRoute: true,
    meta: {
      title: 'Client Sources | Ledgible',
    },
  },
});
